export default {
  listAllMagazine: 'magazine',
}
